export default {
  listAllMagazine: 'magazine',
}
